import * as React from 'react'
import {Button} from '@frontrow/console/src/components/button'
import {H1, H3} from '@frontrow/console/src/components/typography'
import {type CsvFileErrorT} from '@frontrow/console/src/entities/models/roster-sync'

import {type DistrictT} from '@frontrow/console/src/models/district'
import DistrictSearchButtonContainer from '@frontrow/console/src/components/common/district-search-button'
import CsvFileErrors from '@frontrow/console/src/components/common/csv-file-errors'
import ImportRow from '@frontrow/console/src/components/pages/import-sis-ids/import-row'
import SisMatchesDisplayContainer from './sis-matches-display/index'
import {type PatchStudentSisIdT} from '@frontrow/console/src/components/pages/import-sis-ids'
import {type SelectedStudentT} from './sis-matches-display/index'
import * as style from './import-sis-ids.module.scss'

import {type ImportFileType} from '@frontrow/console/src/components/pages/import-sis-ids'

type Props = {
  onImport: (event: React.ChangeEvent<HTMLInputElement>, fileType: ImportFileType) => void
  onMatchStudents: (e: React.FormEvent<HTMLFormElement>) => void
  onPostFetch: (districts: Array<DistrictT>) => void
  teachersFileUploaded: boolean
  studentsFileUploaded: boolean
  coursesFileUploaded: boolean
  enrollmentsFileUploaded: boolean
  onPatchSisIds: (studentSisIds: Array<PatchStudentSisIdT>) => void
  students: Array<SelectedStudentT> | undefined | null
  isPatchSuccess: boolean
  csvMatchErrors: Array<CsvFileErrorT> | undefined | null
  preFetchError: string | undefined | null
  districtName: string
  patchError: string | undefined | null
}

export default function ImportSisIdsPage(props: Props): React.ReactElement {
  const {
    onImport,
    onMatchStudents,
    onPostFetch,
    teachersFileUploaded,
    studentsFileUploaded,
    coursesFileUploaded,
    enrollmentsFileUploaded,
    onPatchSisIds,
    students,
    isPatchSuccess,
    csvMatchErrors,
    preFetchError,
    districtName,
    patchError
  } = props

  const displayFetchResults =
    csvMatchErrors !== null && csvMatchErrors !== undefined ? (
      <CsvFileErrors errors={csvMatchErrors} />
    ) : students !== null && students !== undefined ? (
      <div className={style.sisIdDataTable}>
        <SisMatchesDisplayContainer students={students} onPatchSisIds={onPatchSisIds} />
      </div>
    ) : null

  const displayResult = isPatchSuccess ? <H3>Success!</H3> : displayFetchResults

  const errorMessage =
    preFetchError !== null && preFetchError !== undefined
      ? preFetchError
      : patchError !== null && patchError !== undefined
        ? patchError
        : null

  const errorNode =
    errorMessage !== null && errorMessage !== undefined ? (
      <H3 addClass={style.errorMsg}>Error: {errorMessage}</H3>
    ) : null

  return (
    <React.Fragment>
      <H1>Import SIS IDs</H1>
      <div className={style.districtSearchContainer}>
        <DistrictSearchButtonContainer onPostFetch={onPostFetch} />
        <H3 addClass={style.districtTitle}>{districtName}</H3>
      </div>
      <form onSubmit={onMatchStudents} action="">
        <ImportRow
          title="Teachers"
          type="teachers-csv"
          onImport={onImport}
          uploaded={teachersFileUploaded}
          description="school_id,first_name,last_name,teacher_email"
          templateUrl=""
        />
        <ImportRow
          title="Students"
          type="students-csv"
          onImport={onImport}
          uploaded={studentsFileUploaded}
          description="student_sis_id,first_name,last_name,grade"
          templateUrl=""
        />
        <ImportRow
          title="Courses"
          type="courses-csv"
          onImport={onImport}
          uploaded={coursesFileUploaded}
          description="teacher_email,course_sis_id,name"
          templateUrl=""
        />
        <ImportRow
          title="Enrollments"
          type="enrollments-csv"
          onImport={onImport}
          uploaded={enrollmentsFileUploaded}
          description="student_sis_id,course_sis_id"
          templateUrl=""
        />
        <Button type="submit" disabled={false}>
          Match Students
        </Button>
      </form>
      <br />
      {displayResult}
      {errorNode}
    </React.Fragment>
  )
}
